import { supabase } from '../../../services/supabaseClient';

const MF_TOKEN = 'QOQMRWtDQA9W8pluLNSV';
const TABLE_ADMINS = 'bianca_realestate_admins';

async function verifyAdminAccess(email) {
  if (!email) return null;
  const { data, error } = await supabase
    .from(TABLE_ADMINS)
    .select('email, role, nome, is_dev')
    .eq('token', MF_TOKEN)
    .ilike('email', email.toLowerCase())
    .maybeSingle();
  if (error || !data) return null;
  return data;
}

export async function signInAdmin(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });
  if (error) return { ok: false, error: 'Email ou senha incorretos.' };

  const admin = await verifyAdminAccess(data.user?.email);
  if (!admin) {
    await supabase.auth.signOut();
    return { ok: false, error: 'Sem permissão para acessar este painel.' };
  }

  return { ok: true, user: data.user, admin };
}

export async function signOutAdmin() {
  await supabase.auth.signOut();
}

export async function getCurrentAdmin() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) return null;
  const admin = await verifyAdminAccess(session.user?.email);
  if (!admin) return null;
  return { session, admin };
}

export function onAdminAuthChange(callback) {
  const { data } = supabase.auth.onAuthStateChange((event, session) => {
    callback(event, session);
  });
  return () => data.subscription?.unsubscribe();
}

export async function requestPasswordReset(email) {
  const redirectTo = `${window.location.origin}/mf-real-state/admin?recover=1`;
  const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}

export async function updatePassword(newPassword) {
  const { error } = await supabase.auth.updateUser({ password: newPassword });
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
